export enum CardSetName {
  OneToHundred = "one-to-hundred",
  OneToThirteen = "one-to-thirteen",
  StoXXL = "s-to-xxl",
  EMPTY = "empty"
}

export interface ICardSet {
  cardArray: string[];
}

export const ALL_CARD_SETS: { [key in CardSetName]: ICardSet } = {
  [CardSetName.OneToHundred]: {
    cardArray: [
      "1",
      "2",
      "3",
      "5",
      "8",
      "13",
      "20",
      "40",
      "80",
      "100",
      "?",
      "💣",
      "☕"
    ]
  },
  [CardSetName.OneToThirteen]: {
    cardArray: ["1", "2", "3", "5", "8", "13", "?", "💣", "☕"]
  },
  [CardSetName.StoXXL]: {
    cardArray: ["S", "M", "L", "XL", "XXL", "?", "💣", "☕"]
  },
  [CardSetName.EMPTY]: {
    cardArray: []
  }
};

export function getCardSetByName(cardSetName: CardSetName): ICardSet {
  return ALL_CARD_SETS[cardSetName] || ALL_CARD_SETS[CardSetName.EMPTY];
}
